<template lang="pug">
transition(name="fade")
  slot
</template>

<script>
export default {
  name: "Fade",
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
